import { TwoFactorAuthenticationRegistrationService } from '../two-factor-authentication-registration.service';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TwoFactorAuthenticationRegistrationFormType } from '../two-factor-authentication-registration-form-type';
import { TitleBarComponent } from '../../shared/title-bar/title-bar.component';

import { IRequest2FARegistrationCodeResponseDTO, Request2FARegistrationCodeDTO, Request2FARegistrationCodeResponseDTO, Verify2FARegistrationCodeDTO } from '../../models/models.swagger.generated';
import { StepperAllModule, StepperModule } from '@syncfusion/ej2-angular-navigations';
import { twoFactorAuthenticationRecoveryRoute } from 'src/app/core/routing/route-names';
import { IStepAuthenticateData, StepAuthenticateComponent } from '../steps/step-authenticate/step-authenticate.component';
import { StepQrcodeComponent } from '../steps/step-qrcode/step-qrcode.component';
import { StepVerifyRegistrationComponent, ValidateFormType } from '../steps/step-verify-registration/step-verify-registration.component';
import { StepRegistrationSuccessfulComponent } from '../steps/step-registration-successful/step-registration-successful.component';

@Component({
    selector: 'app-two-factor-authentication-registration',
    templateUrl: './two-factor-authentication-registration.component.html',
    styleUrls: ['./two-factor-authentication-registration.component.scss'],
    imports: [TitleBarComponent, StepperAllModule, StepperModule, StepAuthenticateComponent, StepQrcodeComponent, StepVerifyRegistrationComponent, StepRegistrationSuccessfulComponent]
})
export class TwoFactorAuthenticationRegistrationComponent {
  public loading = false;
  public qrData: IRequest2FARegistrationCodeResponseDTO;
  public stepIndex = 0;
  public stepAuthenticateData: IStepAuthenticateData = {
    header: 'i18n.base.two-factor-authentication.registration.step1-header',
    description: 'i18n.base.two-factor-authentication.registration.step1-description',
    linkLabel: 'i18n.base.two-factor-authentication.registration.recover-2FA',
    linkRoute: twoFactorAuthenticationRecoveryRoute,
    buttonText: 'i18n.base.two-factor-authentication.registration.get-code'
  };

  private form: FormGroup<TwoFactorAuthenticationRegistrationFormType>;

  constructor(
    private service: TwoFactorAuthenticationRegistrationService
  ) { }

  public requestCode(form: FormGroup<TwoFactorAuthenticationRegistrationFormType>): void {
    if (form.invalid || this.loading) {
      return;
    }
    var request = new Request2FARegistrationCodeDTO({userName: form.value.userName, password: form.value.password});
    this.form = form;
    this.service.requestCode(request).subscribe({
      next: (response: Request2FARegistrationCodeResponseDTO) => {
        this.qrData = response;
        this.loading = false;
        this.stepIndex = 1;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  public onQrCodeRegistered(): void {
    this.stepIndex = 2;
  }

  public validateRegistration(validateForm: FormGroup<ValidateFormType>): void {
    if (this.form.invalid || validateForm.invalid || this.loading) {
      return;
    }
    this.service.verifyRegistration(new Verify2FARegistrationCodeDTO({userName: this.form.value.userName, password: this.form.value.password, code: validateForm.value.token})).subscribe({
      next: () => {
        this.loading = false;
        this.stepIndex = 3;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  public navigateBack(): void {
    this.stepIndex--;
  }
}
